export class SapAgent {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "deploymentShape",
            "baseName": "deploymentShape",
            "type": "SapDeploymentShape",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SapAgentStatus",
            "format": ""
        },
        {
            "name": "agentVersion",
            "baseName": "agentVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastHeartbeat",
            "baseName": "lastHeartbeat",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "cdcLagSeconds",
            "baseName": "cdcLagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SapAgent.attributeTypeMap;
    }
    constructor() {
    }
}
